function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '@bydesign-ui/hooks';
import { modAccurately } from '@bydesign-ui/utils';
export var Axis = function (_Emitter) {
  _inherits(Axis, _Emitter);

  var _super = _createSuper(Axis);

  function Axis(region, type, isSlider) {
    var _this;

    _classCallCheck(this, Axis);

    _this = _super.call(this);
    _this.step = 1;
    _this.min = 0;
    _this.max = 0;
    _this.strict = false;
    _this.type = type;
    _this.region = region;
    _this.isSlider = !!isSlider;
    return _this;
  }

  _createClass(Axis, [{
    key: "getAxisType",
    value: function getAxisType() {
      return this.type;
    }
  }, {
    key: "getRegion",
    value: function getRegion() {
      return this.region;
    }
  }, {
    key: "getAxisLength",
    value: function getAxisLength() {
      return this.region.getAxisLength(this.type);
    }
  }, {
    key: "getValueOffset",
    value: function getValueOffset(value) {
      if (this.isSlider) {
        return (value - this.min) / (this.max - this.min) * this.getAxisLength();
      }

      return Math.floor((value - this.min) / (this.max - this.min) * this.getAxisLength());
    }
  }, {
    key: "getAxisConfig",
    value: function getAxisConfig() {
      return {
        strict: this.strict,
        max: this.max,
        min: this.min,
        step: this.step,
        precision: this.getMaxPrecision()
      };
    }
  }, {
    key: "updateAxisConfig",
    value: function updateAxisConfig(config) {
      var _config$strict = config.strict,
          strict = _config$strict === void 0 ? false : _config$strict,
          _config$step = config.step,
          step = _config$step === void 0 ? 1 : _config$step,
          precision = config.precision,
          min = config.min,
          max = config.max;
      this.step = step;
      this.precision = precision;
      this.strict = strict;

      if (config.strict) {
        if (min == null || max == null) {
          throw new Error('props `min` and `max` are required in strict mode');
        }

        this.min = min;
        this.max = max;

        if (!this.isValidValue(max)) {
          throw new Error("max is invalid:  max = ".concat(max, " doesn't match formula `min + step * n, n is integer`"));
        }
      } else {
        this.min = min == null ? Number.MIN_SAFE_INTEGER : min;
        this.max = max == null ? Number.MAX_SAFE_INTEGER : max;
      }

      this.repaint();
    }
  }, {
    key: "updateAxisPrecision",
    value: function updateAxisPrecision(precision) {
      this.precision = precision;
    }
  }, {
    key: "repaint",
    value: function repaint() {
      this.emit('repaint');
    }
  }, {
    key: "formatPrecisionValue",
    value: function formatPrecisionValue(val, precisionValue) {
      var precision = this.getMaxPrecision(precisionValue);

      if (!isNaN(precision)) {
        return val.toFixed(precision);
      }

      return String(val);
    }
  }, {
    key: "getOffsetPrecisionValue",
    value: function getOffsetPrecisionValue(offset) {
      var max = this.max,
          min = this.min;

      if (this.getAxisLength() === 0) {
        return this.formatPrecisionValue(this.getValidValue(0));
      }

      return this.formatPrecisionValue(this.getValidValue(offset / this.getAxisLength() * (max - min) + min));
    }
  }, {
    key: "isValidPrecisionValue",
    value: function isValidPrecisionValue(value) {
      return this.isValidValue(+value);
    }
  }, {
    key: "isValidValue",
    value: function isValidValue(value) {
      var strict = this.strict,
          min = this.min,
          max = this.max,
          step = this.step;

      if (isNaN(value)) {
        return false;
      }

      if (min != null && value < min || max != null && value > max) {
        return false;
      }

      if (strict) {
        return modAccurately(value - min, step) === 0;
      }

      return true;
    }
  }, {
    key: "getMaxPrecision",
    value: function getMaxPrecision(value) {
      if (this.precision != null) {
        return this.precision;
      }

      var minPrecision = Axis.getPrecision(this.min);
      var maxPrecision = Axis.getPrecision(this.max);
      var stepPrecision = Axis.getPrecision(this.step);
      var currentValuePrecision = value == null ? 0 : Axis.getPrecision(value);
      return Math.max(currentValuePrecision, stepPrecision, minPrecision, maxPrecision);
    }
  }, {
    key: "isValueSelected",
    value: function isValueSelected(value) {
      return this.region.isAxisSelected(this.type, value);
    }
  }, {
    key: "isAxisSelected",
    value: function isAxisSelected(value) {
      return this.region.isAxisSelected(this.type, value);
    }
  }, {
    key: "getValidValue",
    value: function getValidValue(value) {
      var val = value;

      if (isNaN(val)) {
        throw new Error("".concat(val, " is not a valid number"));
      }

      if (this.strict) {
        var count = Math.round((val - this.min) / this.step);
        val = count * this.step + this.min;
      }

      if (this.min != null && val < this.min) {
        val = this.min;
      }

      if (this.max != null && val > this.max) {
        val = this.max;
      }

      return val;
    }
  }, {
    key: "stepPrecisionValue",
    value: function stepPrecisionValue(value) {
      var stepCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return this.formatPrecisionValue(this.getValidValue(Number(value) + stepCount * this.step), value);
    }
  }], [{
    key: "getPrecision",
    value: function getPrecision(value) {
      var valueString = value.toString();

      if (valueString.indexOf('e-') >= 0) {
        return parseInt(valueString.slice(valueString.indexOf('e-') + 2), 10);
      }

      var precision = 0;

      if (valueString.indexOf('.') >= 0) {
        precision = valueString.length - valueString.indexOf('.') - 1;
      }

      return precision;
    }
  }]);

  return Axis;
}(Emitter);